"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LayerGroupCollections = void 0;
var LayerGroupCollections = /** @class */ (function () {
    function LayerGroupCollections(layerGroupCollections) {
        this.layerGroupCollections = layerGroupCollections;
        this.isVectorLayerGroup = function (layerGroup) {
            return layerGroup.hasZoomedToBounds !== undefined;
        };
    }
    Object.defineProperty(LayerGroupCollections.prototype, "allLayers", {
        get: function () {
            var layerGroups = new Array();
            this.layerGroupCollections.forEach(function (lgc) {
                lgc.layerGroups.forEach(function (lg) {
                    layerGroups.push(lg);
                });
            });
            return layerGroups;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LayerGroupCollections.prototype, "vectorLayerGroups", {
        get: function () {
            var _this = this;
            var lgs = new Array();
            this.layerGroupCollections.forEach(function (lgc) {
                lgc.layerGroups.forEach(function (lg) {
                    if (_this.isVectorLayerGroup(lg)) {
                        lgs.push(lg);
                    }
                });
            });
            return lgs;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LayerGroupCollections.prototype, "wmsLayerGroups", {
        get: function () {
            var _this = this;
            var lgs = new Array();
            this.layerGroupCollections.forEach(function (lgc) {
                lgc.layerGroups.forEach(function (lg) {
                    if (!_this.isVectorLayerGroup(lg)) {
                        lgs.push(lg);
                    }
                });
            });
            return lgs;
        },
        enumerable: false,
        configurable: true
    });
    return LayerGroupCollections;
}());
exports.LayerGroupCollections = LayerGroupCollections;
//# sourceMappingURL=LayerGroupCollections.js.map